import React from 'react'

export default function Button({ text, primary, onClick, className, buy }) {
  if(primary==="white") {
    return (
      <button onClick={onClick} className={`bg-white hover:bg-grey-200 text-black text-sm sm:text-base px-4 py-1 rounded h-10 ${className}`}>{text}</button>
    )
  } else if (primary==="blackBorder") {
    return(
    <button onClick={onClick} className={`bg-white text-lpGray border border-lpGray hover:bg-lpGray hover:text-white text-sm sm:text-base px-4 py-1 rounded h-10 ${className}`}>{text}</button>
    )
  } else if (primary==="transparent") {
    return(
    <button onClick={onClick} className={`text-lpGray border border-lpGray hover:bg-lpGray hover:text-white text-xs sm:text-base px-1 sm:px-4 py-1 rounded h-10 ${className}`}>{text}</button>
    )
  } else {
    return (
      <button onClick={onClick} className={`bg-primary hover:bg-primary-light text-white text-sm sm:text-base px-4 py-1 rounded h-10 ${className}`}>{buy && "Buy"} {text}</button>
    )
  }
}
